// Action Types fror Quote

// Get Quote List
export const GET_QUOTE_LIST = "GET_QUOTE_LIST";
export const GET_QUOTE_LIST_SUCCESS = "GET_QUOTE_LIST_SUCCESS";
export const GET_QUOTE_LIST_FAILURE = "GET_QUOTE_LIST_FAILURE";

// Get Quote Details
export const GET_QUOTE_DETAILS = "GET_QUOTE_DETAILS";
export const GET_QUOTE_DETAILS_SUCCESS = "GET_QUOTE_DETAILS_SUCCESS";
export const GET_QUOTE_DETAILS_FAILURE = "GET_QUOTE_DETAILS_FAILURE";

// Create Quote
export const CREATE_QUOTE = "CREATE_QUOTE";
export const CREATE_QUOTE_SUCCESS = "CREATE_QUOTE_SUCCESS";
export const CREATE_QUOTE_FAILURE = "CREATE_QUOTE_FAILURE";

// Update Quote
export const UPDATE_QUOTE = "UPDATE_QUOTE";
export const UPDATE_QUOTE_SUCCESS = "UPDATE_QUOTE_SUCCESS";
export const UPDATE_QUOTE_FAILURE = "UPDATE_QUOTE_FAILURE";

// Delete Quote
export const DELETE_QUOTE = "DELETE_QUOTE";
export const DELETE_QUOTE_SUCCESS = "DELETE_QUOTE_SUCCESS";
export const DELETE_QUOTE_FAILURE = "DELETE_QUOTE_FAILURE";

// Get Quote Status List
export const GET_QUOTE_STATUS_LIST = "GET_QUOTE_STATUS_LIST";
export const GET_QUOTE_STATUS_LIST_SUCCESS = "GET_QUOTE_STATUS_LIST_SUCCESS";
export const GET_QUOTE_STATUS_LIST_FAILURE = "GET_QUOTE_STATUS_LIST_FAILURE";

// Quote get Pdf api
export const GET_QUOTE_PDF = "GET_QUOTE_PDF";
export const GET_QUOTE_PDF_SUCCESS = "GET_QUOTE_PDF_SUCCESS";
export const GET_QUOTE_PDF_FAILURE = "GET_QUOTE_PDF_FAILURE";

// Add New Quote Status
export const ADD_NEW_QUOTE_STATUS = "ADD_NEW_QUOTE_STATUS";
export const ADD_NEW_QUOTE_STATUS_SUCCESS = "ADD_NEW_QUOTE_STATUS_SUCCESS";
export const ADD_NEW_QUOTE_STATUS_FAILURE = "ADD_NEW_QUOTE_STATUS_FAILURE";

// Update Quote Status
export const UPDATE_QUOTE_STATUS = "UPDATE_QUOTE_STATUS";
export const UPDATE_QUOTE_STATUS_SUCCESS = "UPDATE_QUOTE_STATUS_SUCCESS";
export const UPDATE_QUOTE_STATUS_FAILURE = "UPDATE_QUOTE_STATUS_FAILURE";

// Delete Quote Status
export const DELETE_QUOTE_STATUS = "DELETE_QUOTE_STATUS";
export const DELETE_QUOTE_STATUS_SUCCESS = "DELETE_QUOTE_STATUS_SUCCESS";
export const DELETE_QUOTE_STATUS_FAILURE = "DELETE_QUOTE_STATUS_FAILURE";

// single customer quote  list
export const GET_SINGLE_CUSTOMER_QUOTE_LIST = "GET_SINGLE_CUSTOMER_QUOTE_LIST";
export const GET_SINGLE_CUSTOMER_QUOTE_LIST_SUCCESS =
  "GET_SINGLE_CUSTOMER_QUOTE_LIST_SUCCESS";
export const GET_SINGLE_CUSTOMER_QUOTE_LIST_FAILURE =
  "GET_SINGLE_CUSTOMER_QUOTE_LIST_FAILURE";
